module.exports = __webpack_public_path__ + "images/ranking-events-rating-drops-74650a88.svg";